export default __webpack_public_path__ + "static/media/Sa part d'ombre.d77acda8.jpg";